import React from 'react';
import { svg } from '../assets/svg/common.js'

function NoSelect() {

    return (
        <>
            <div className="col d-flex justify-content-center align-items-center">
                <div className='position-fixed top-50 d-flex flex-column justify-content-center align-items-center'>
                    <span className="no-msg-logo">{svg.select_msg}</span>
                    <h3>Select Message!</h3>
                </div>
            </div>
        </>
    );
}

export default NoSelect;
